import { ref } from 'vue'

function cloneArray(value) {
  return Array.isArray(value) ? [...value] : []
}

export function cloneNavData(navData = {}) {
  return {
    ...navData,
    rail_items: cloneArray(navData.rail_items),
    panels: { ...(navData.panels || {}) },
    footer_links: cloneArray(navData.footer_links),
  }
}

export function useNavData(initialNavData) {
  const localNavData = ref(cloneNavData(initialNavData))

  function applyNavAuthPayload(eventOrPayload) {
    const payload = eventOrPayload?.detail || eventOrPayload || {}
    localNavData.value = cloneNavData(payload)
  }

  return {
    localNavData,
    applyNavAuthPayload,
  }
}
